import { render, staticRenderFns } from "./VPs.vue?vue&type=template&id=46b85274&"
import script from "./VPs.vue?vue&type=script&lang=js&"
export * from "./VPs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports